import { FARE_BASIS_CODE_SASH } from '@/constants';

const getFlightsSashText = (flights) =>
  Object.keys(FARE_BASIS_CODE_SASH).find((key) => {
    const fareBasis = FARE_BASIS_CODE_SASH[key];

    return flights?.some((f) => f.fareBasis?.includes(fareBasis));
  });

export default getFlightsSashText;
